import { render } from "./config-GS.vue?vue&type=template&id=28d95ceb"
import script from "./config-GS.vue?vue&type=script&lang=js"
export * from "./config-GS.vue?vue&type=script&lang=js"

import "./config-GS.vue?vue&type=style&index=0&id=28d95ceb&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__